module.exports = "/_next/static/images/icon__expand-792f5da4e4fd048193eb13e02eddc354.png";